import { createFileRoute, redirect } from "@tanstack/react-router";
import { readWorkspaceNavigation, workspaceNavigationHref } from "@/features/builder/lib/workspaceNavigation";

// Canonical area paths, with a redirect for old site-id bookmarks and payment callbacks.
export const Route = createFileRoute("/builder/$")({
  beforeLoad: ({ location }) => {
    const canonical = workspaceNavigationHref(readWorkspaceNavigation(location.pathname, location.searchStr), location.searchStr, location.hash);
    if (new URL(canonical, "https://portal.test").pathname !== new URL(location.pathname, "https://portal.test").pathname) throw redirect({ href: canonical, replace: true });
  },
});
